// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-style .ant-card-cover{-webkit-transform:none;transform:none;margin:0}.card-style .ant-card-actions{border-radius:0 0 15px 15px;border-top:none}.card-style .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input{padding:4.5px 14px}\n", ""]);
// Exports
module.exports = exports;
